import { BrowserRouter as Router } from 'react-router-dom'
import { Suspense } from 'react'
import { Provider } from 'react-redux'
import { AuthProvider } from '@praxis/component-auth'
import { AnalyticsProvider } from '@praxis/analytics/client'
import { Spinner } from '@enterprise-ui/canvas-ui-react'
import { HelveticaForTarget } from '@enterprise-ui/component-font'
import { ApolloProvider } from '@apollo/client'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'
import { findAppPath } from './resources/searchUtills'
import apiConfig from './config/'
import store from './store/'
import { client } from './graphql/'
import { Main } from './views/main/'

import '@enterprise-ui/canvas-ui-css'
import './styles/customStyles.scss'

const config = {
  apiKey: apiConfig.analytics.apiKey,
  serviceName: 'veitemsearch',
}

OpenTelemetryManager.initialize(config)

const App = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <HelveticaForTarget variants={['n4', 'n5', 'n7']} />
      <Router basename={findAppPath()}>
        <AuthProvider {...apiConfig.auth}>
          <ApolloProvider client={client}>
            <Provider store={store}>
              <AnalyticsProvider
                config={apiConfig.analytics}
                trackClicks
                trackLocations
              >
                <Main />
              </AnalyticsProvider>
            </Provider>
          </ApolloProvider>
        </AuthProvider>
      </Router>
    </Suspense>
  )
}

export default App
